import { nanoid } from 'nanoid/non-secure';

import { ACTIONS } from '../../constants';
import { renderModel } from '../../util/renderModel';
import { IWidgetSessionState, TSessionActions } from './types';

const initialState: IWidgetSessionState = {
  // TODO: should we move this to common channel(to have it in each event)
  sessionTabId: nanoid(),
  sessionId: renderModel.getWidgetSessionId(),
};

export const widgetSessionReducer = (
  state = initialState,
  action: TSessionActions,
): IWidgetSessionState => {
  switch (action.type) {
    case ACTIONS.URL_CHANGED: {
      return {
        ...state,
        sessionTabId: initialState.sessionTabId, // this sessionTabId can not be changed.
        addedUrl: action.addedUrl,
        replacedUrl: action.replacedUrl,
        removeLast: action.removeLast,
      };
    }
    case ACTIONS.SET_SESSION_ID: {
      return {
        ...state,
        sessionId: action.sessionId,
      };
    }
    default: {
      return state;
    }
  }
};
